<div>
    <span id="position-table-header" class="section-title">Position details</span>
    <a data-testid="multipleItDetails_editPositionsDetailsLink" class="editpositiondetails" (click)="onEditClicked()" *ngIf="!isInitiateAndReleaseFlowFromTable && !isOneTimeTotalDist">Edit position details</a>
</div>

<div id="multipleItDetails_positionsDisclaimer">
    <mm-banners [bannerText]="[positionsViewPageBannerMessageText]" [type]="'information'" [showCloseIcon]="false"></mm-banners>
</div>

<div *ngIf="classifications.isIra" id="taxesApplicable_disclaimer">
    <mm-banners [bannerText]="[taxesApplicableViewPageBannerMessageText]" [type]="'information'" [showCloseIcon]="false"></mm-banners>
</div>

<div id="positions-details-review" *ngFor="let account of toAccountsData; index as i">
    <div attr.id="positions-details-review-table-{{i}}">
        <div id="table-toolbar">
            <span id="account-info">
                <span id="account-name">{{account.accountRegistration}}</span>
                <span id="account-number">Account #: {{account.accountId}}</span>
                <span id="account-type"> | {{account.regType}}</span>
            </span>
            <span id="table-options">
                <span *ngIf="isManualLotSelection" class="expandAll">
                    View lot details
                    <label class="switch">
                        <input type="checkbox" id="expandAllId" (click) = "expandOrCollapse(i)" checked>
                        <span class="slider round"></span>
                        <span class="labels" data-on="ON" data-off="OFF"></span>
                    </label>
                </span>
            </span>
        </div>
    </div>
    <div>
    </div>
    <ng-template [ngIf]="((account.rowData$ | async) || []).length === 0">
        <sdps-divider variation="secondary"></sdps-divider>
        <div class='errorMsgContainer'>
            <sdps-icon color="secondary" type="functional" name="warning" size="medium"></sdps-icon>
            <div class='message'>{{noPositionsMessage}}</div>
        </div>
    </ng-template>
    <div *ngIf="((account.rowData$ | async) || []).length > 0">
        <ag-grid-angular #positionTableGrid class="sac-ag-grid ag-theme-material" id="review-position-table-multiple"
        [detailRowAutoHeight]="true" [getRowHeight]="getRowHeight" [gridOptions]="gridOptions"
        [rowData]="(account.rowData$ | async)" [columnDefs]="columnDefs" [defaultColDef]="defaultColumnDefs" [icons]="icons"
        [headerHeight]="35" [keepDetailRows]="true" [pagination]="true" [paginationPageSize]="10"
        [suppressPaginationPanel]="true" [suppressMultiSort]="true" (gridReady)="onGridReady($event)"
        [suppressRowClickSelection]="true" [suppressDragLeaveHidesColumns]="true" [suppressHorizontalScroll]="true"
        [components]="frameworkComponents" domLayout="autoHeight" [embedFullWidthRows]="true"
        [keepDetailRows]="true" [modules]="modules" [animateRows]="true" [masterDetail]="this.isMasterDetail()"
        [detailCellRendererParams]="detailCellRendererParams" [alignedGrids]="[totalsTableGrid]">
        </ag-grid-angular>
        <ag-grid-angular #totalsTableGrid class="sac-ag-grid ag-theme-material" [rowData]="totalsRowdata" id="review-position-totals-table-multiple"
            [columnDefs]="columnDefs" [getRowHeight]="getRowHeight" [gridOptions]="gridOptionsTotals" [icons]="icons"
            [pagination]="true" [paginationPageSize]="10" [headerHeight]="25" domLayout="autoHeight" [headerHeight]="0"
            [suppressPaginationPanel]="true" (gridReady)="onGridReadyTotals($event)" [alignedGrids]="[positionTableGrid]" [modules]="globalModules">
        </ag-grid-angular>
    </div>
    
    <span>
        <mm-pagination [gridApi]="gridApis[i]"></mm-pagination>
    </span>
</div>